<template>
  <div class="row">
    <div class="col text-center my-5">
      <h1 class=""><icon icon="check-circle" class="text-success"/></h1>
      <h1 class="my-4">Thank you for signing up</h1>
      <p class="pb-4">A confirmation email was sent to your email address.<br>Please click on the link in the email to complete registration</p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'validate-email'
}
</script>
